/**
 * Created by kubla on 01/05/17.
 */
import Constants from '../js/constants'

export function ruoloLega(ruolo) {
  return Constants.RUOLI_LEGA[ruolo]
}

export function eliminazioniSquadreDisponibili(astaInfo) {
  const count = astaInfo.eliminazioniSquadre
    ? astaInfo.eliminazioniSquadre.count
    : 0;
  return Math.max(0, Constants.MAX_ELIMINAZIONI_SQUADRE - count);
}

export function eliminaSquadraDisabledReason(standalone, uid, astaInfo, round, squadraId, squadra) {
  if (!standalone || !uid || astaInfo.admin !== uid) {
    return "Solo l'amministratore d'asta può eliminare una squadra.";
  }
  if (!squadra) return "La squadra non è più presente nell'asta.";
  if (squadraId === astaInfo.admin) {
    return "Prima di eliminare la tua squadra devi trasferire l'incarico di amministratore.";
  }
  if (astaInfo.settings.status !== Constants.ASTA_STATUS.NOT_RUNNING || round.calciatoreInAsta != null) {
    return "Ferma l'asta e annulla l'eventuale calciatore in assegnazione prima di eliminare una squadra.";
  }
  if (!eliminazioniSquadreDisponibili(astaInfo)) {
    return "Hai raggiunto il limite di 3 eliminazioni per questa asta.";
  }
  return "";
}

export function maxOfferta(lega, residui, ncalciatori) {
  // illimitati, un massimo di
  if (lega.nRuoli.op == "illimitati" || lega.nRuoli.op == "<=") {
    return residui;
  }
  // esattamente, almeno
  let ncr = lega.nRuoli.nP + lega.nRuoli.nD + lega.nRuoli.nC + lega.nRuoli.nA;
  let min_offerta = Constants.OFFERTA.MINIMA;
  return Math.min(residui, parseFloat(residui - (ncr - ncalciatori) * min_offerta + min_offerta));
}

export function minOfferta(base_asta, calciatore) {
  if (base_asta == Constants.BASE_ASTA.QUOTAZIONE && calciatore)
    return parseFloat(calciatore.quotazione)
  return parseFloat(base_asta);
}

export function statiMercatiOptions(tipoMercato) {
  return tipoMercato && tipoMercato.statiMercatiOptions
    ? tipoMercato.statiMercatiOptions
    : [];
}

export function statoMercatoText(tipoMercato, statoMercato) {
  const option = statiMercatiOptions(tipoMercato).find(
    (item) => item.id == statoMercato
  );
  return option && option.text ? option.text : statoMercato;
}

export function assegnaHintText(modeRandom, isMobile) {
  if (modeRandom) {
    let text = "L'amministratore d'asta può estrarre casualmente un calciatore";
    if (isMobile) {
      text +=
        " oppure sceglierlo dagli Svincolati (vedi tasto in basso a sinistra)";
    } else {
      text += " oppure sceglierlo dagli Svincolati";
    }
    text += " e poi scegliere a chi assegnarlo.";
    return text;
  }

  let text = "L'amministratore d'asta deve cliccare sugli Svincolati";
  if (isMobile) {
    text += " (vedi tasto in basso a sinistra)";
  }
  text += " e poi scegliere a chi assegnarli.";
  return text;
}

export function ruoliClassicIds() {
  return Object.keys(Constants.RUOLI_NEW).map((ID_Ruolo) =>
    parseInt(ID_Ruolo)
  );
}

export function normalizeLimitRosaPerClub(limitRosaPerClub) {
  if (!limitRosaPerClub) {
    return {activeMode: "no"};
  }

  if (limitRosaPerClub.activeMode === "perRuolo") {
    const valori = {};
    ruoliClassicIds().forEach((ID_Ruolo) => {
      const valore =
        limitRosaPerClub.valori &&
        limitRosaPerClub.valori[ID_Ruolo] !== undefined
          ? parseInt(limitRosaPerClub.valori[ID_Ruolo])
          : "";
      valori[ID_Ruolo] = valore > 0 ? valore : "";
    });
    return {
      activeMode: "perRuolo",
      valori,
    };
  }

  if (limitRosaPerClub.activeMode === "totale") {
    return {
      activeMode: "totale",
      valore:
        parseInt(limitRosaPerClub.valore) > 0
          ? parseInt(limitRosaPerClub.valore)
          : "",
      ignoreRuoli: _.map(limitRosaPerClub.ignoreRuoli || [], (ID_Ruolo) =>
        parseInt(ID_Ruolo)
      ),
    };
  }

  // legacy
  if (
    limitRosaPerClub.perClubPerRuolo &&
    limitRosaPerClub.perClubPerRuolo.active == 1 &&
    parseInt(limitRosaPerClub.perClubPerRuolo.valore) > 0
  ) {
    const valore = parseInt(limitRosaPerClub.perClubPerRuolo.valore);
    return {
      activeMode: "perRuolo",
      valori: _.fromPairs(
        ruoliClassicIds().map((ID_Ruolo) => [ID_Ruolo, valore])
      ),
    };
  }

  return {activeMode: "no"};
}

export function isLimitRosaPerClubActive(limitRosaPerClub) {
  return !!limitRosaPerClub && limitRosaPerClub.activeMode !== "no";
}

export function limitRosaPerClubText(limitRosaPerClub) {

  // non dovrebbe servire e potrei toglierla
  limitRosaPerClub = normalizeLimitRosaPerClub(limitRosaPerClub);

  if (!isLimitRosaPerClubActive(limitRosaPerClub)) {
    return "Nessun limite";
  }

  if (limitRosaPerClub.activeMode === "perRuolo") {
    return "Per ruolo: " + _.map(ruoliClassicIds(), (ID_Ruolo) => {
      const label = Constants.RUOLI_NEW[ID_Ruolo].abc;
      const valore = limitRosaPerClub.valori[ID_Ruolo];
      return label + " " + (valore ? "max " + valore : "ignorato");
    }).join(", ");
  }
  if (limitRosaPerClub.activeMode === "totale") {
    const output = "Totale per rosa: " + limitRosaPerClub.valore;
    if (!limitRosaPerClub.ignoreRuoli.length) {
      return output;
    }
    return output + " (esclusi " + _.map(limitRosaPerClub.ignoreRuoli, (ID_Ruolo) => {
      return Constants.RUOLI_NEW[ID_Ruolo].abc;
    }).join(", ") + ")";
  }
  return "";
}

export function countAcquistiPerClubTotale(acquistiPerClub, ID_Club, ignoreRuoli = []) {
  return _.sum(
    _.map(acquistiPerClub || {}, (num, key) => {
      const parts = key.split("_");
      const ID_RuoloKey = parseInt(parts[0]);
      const ID_ClubKey = parseInt(parts[1]);
      if (ID_ClubKey != ID_Club || ignoreRuoli.indexOf(ID_RuoloKey) !== -1) {
        return 0;
      }
      return parseInt(num);
    })
  );
}

export function isLocalRuntime() {
  return ["localhost", "127.0.0.1", "0.0.0.0"].includes(
    window.location.hostname
  );
}

// not used perchè l'ho spostato come prop in asta_squadre
// export function isRosaCompleta(squadra, asta_info, calciatori) {
//   if (!squadra) return false;
//   if (asta_info.lega.nRuoli.op == "illimitati" ||
//     asta_info.lega.nRuoli.op == ">=") {
//     // illimintati o almeno
//     return false;
//   } else {
//     // esattamente o un massimo di
//     // c'è almeno un ruolo che non è ancora completo?
//     for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
//       const ruolo_id = ruolo.ruolo_id;
//       const isRuoloCompleto = this.isRuoloCompleto(ruolo_id, squadra, asta_info, calciatori)
//       if (isRuoloCompleto == false) return false
//     }
//     return true
//   }
// }

// export function isRuoloCompleto_old(ruolo_id, squadra, asta_info, calciatori) {
//   if (!ruolo_id) return false;
//   if (!squadra) return false;
//   if (asta_info.lega.nRuoli.op == "illimitati" ||
//     asta_info.lega.nRuoli.op == ">=") {
//     // illimintati o almeno
//     return false;
//   } else {
//     // esattamente o un massimo di
//     let output = false;
//     let counter = 0;
//     _.each(squadra.calciatori, (value, calciatore_id) => {
//       let ID_Ruolo = calciatori[calciatore_id].ID_Ruolo
//       if (ID_Ruolo == ruolo_id) counter++
//     });
//     const ruolo_n = Constants.RUOLI_NEW[ruolo_id].n;
//     if (counter >= parseFloat(asta_info.lega.nRuoli[ruolo_n])) output = true
//     return output
//   }
// }

export function isRuoloCompleto(ruolo_id, nAcquistiRuolo, asta_info) {
  if (!ruolo_id) return false;
  if (asta_info.lega.nRuoli.op == "illimitati" ||
    asta_info.lega.nRuoli.op == ">=") {
    // illimintati o almeno
    return false;
  } else {
    // esattamente o un massimo di
    let output = false;
    const nRuoli = asta_info.lega.nRuoli[Constants.RUOLI_NEW[ruolo_id].n];
    if (nAcquistiRuolo >= parseFloat(nRuoli)) output = true
    return output
  }
}

export function roundCompletato(offerte, migliore_offerta, asta_mode, asta_round) {
  ////// aggiunto da diego
  if (asta_mode == Constants.ASTA_MODE.BUSTA_CHIUSA) {
    if (
      asta_round.step == null ||
      asta_round.step.type === Constants.ROUND_STEP.OFFERTE
    ) {
      return false;
    }
  }
  ////////
  let _offerte = _.values(offerte);
  return _.size(_offerte) > 0 && _offerte.every(function(value) {
    return value >= 0;
  }) && _.sum(_offerte) == migliore_offerta;
}

export function offerteCompletate(offerte) {
  let _offerte = _.values(offerte);
  return _.size(_offerte) > 0 && _offerte.every(function(value) {
    return value >= 0;
  });
}

export function findNextSquadraIdAsChooser(asta_choosers, chooserCorrente) {
  return this.findNextSquadraId(asta_choosers, chooserCorrente, (squadraChooser) => { return squadraChooser.canBeChooser });
}

// findNextSquadraIdAsChooser(chooserCorrente) {
//   let asta_choosers = store.getters.asta_choosers;
//   let choosers = Utils.rotateArray(asta_choosers, chooserCorrente);
//   return _.head(choosers) || null;
// }

export function findNextSquadraId(squadre_array, current_squadra_id, func) {

  const startIndex = squadre_array.findIndex(item => item.id == current_squadra_id);

  if (startIndex === -1) {
    // If current_squadra_id is not found, return the first element that satisfies func
    const firstSuitableSquadra = squadre_array.find(func);
    return (firstSuitableSquadra) ? firstSuitableSquadra.id : null;
  }

  const length = squadre_array.length;

  for (let i = 1; i <= length; i++) { // only 1 loop => avoid infinite loop
    const nextIndex = (startIndex + i) % length; // Circular indexing
    const nextSquadra = squadre_array[nextIndex];
    if (func(nextSquadra)) {
      return nextSquadra.id;
    }
  }
  return null; // Return null if no matching is found
}

// export function calcoloOfferta(asta, squadra, calciatore, offerta_corrente) {
//   let offerta = null;

//   // calciatore !== null all'inizio del round
//   if (calciatore !== null) {
//     if (asta.lega.nRuoli.op !== "illimitati" && squadra.acquisti[calciatore.ID_Ruolo] >= asta.lega.nRuoli[ruoloLega(calciatore.ID_Ruolo)]) {
//       offerta = Constants.OFFERTA.PASSO;
//     } else if (asta.lega.limitRosaPerClub.perClubPerRuolo.active == 1 && squadra.acquistiPerClub[calciatore.ID_Ruolo + "_" + calciatore.ID_Club] >= parseInt(asta.lega.limitRosaPerClub.perClubPerRuolo.valore)) {
//       offerta = Constants.OFFERTA.PASSO;
//     } else {
//       offerta = Constants.OFFERTA.INIT;
//     }
//   }

//   if (squadra.max_offerta < offerta_corrente) {
//     offerta = Constants.OFFERTA.PASSO;
//   }

//   return offerta;
// }


export function canJoinRoundWithReason(regole_lega, squadra, calciatore, crediti_min) {
  if (!regole_lega || !squadra || !calciatore) {
    return {
      canJoin: false,
      reason: "Dati non disponibili",
    };
  }

  if (regole_lega.nRuoli.op == "<=" || regole_lega.nRuoli.op == "=") {
    let acquisti = squadra.acquisti || {};
    if (acquisti[calciatore.ID_Ruolo] >= regole_lega.nRuoli[ruoloLega(calciatore.ID_Ruolo)]) {
      return {
        canJoin: false,
        reason: "Ruolo completato",
      };
    }
  }
  const limitRosaPerClub = regole_lega.limitRosaPerClub;
  if (isLimitRosaPerClubActive(limitRosaPerClub)) {
    if (limitRosaPerClub.activeMode === "perRuolo") {
      const valore = limitRosaPerClub.valori[calciatore.ID_Ruolo];
      if (
        valore &&
        (squadra.acquistiPerClub || {})[
          calciatore.ID_Ruolo + "_" + calciatore.ID_Club
        ] >= valore
      ) {
        return {
          canJoin: false,
          reason: "Limite ruolo per club raggiunto",
        };
      }
    }
    if (limitRosaPerClub.activeMode === "totale") {
      const ID_Ruolo = parseInt(calciatore.ID_Ruolo);
      if (
        limitRosaPerClub.valore &&
        limitRosaPerClub.ignoreRuoli.indexOf(ID_Ruolo) === -1 &&
        countAcquistiPerClubTotale(
          squadra.acquistiPerClub || {},
          calciatore.ID_Club,
          limitRosaPerClub.ignoreRuoli
        ) >=
          limitRosaPerClub.valore
      ) {
        return {
          canJoin: false,
          reason: "Limite totale per club raggiunto",
        };
      }
    }
  }
  if (squadra.max_offerta < crediti_min) {
    return {
      canJoin: false,
      reason: "Crediti insufficienti",
    };
  }
  return {
    canJoin: true,
    reason: null,
  };
}

export function canJoinRound(regole_lega, squadra, calciatore, crediti_min) {
  return canJoinRoundWithReason(
    regole_lega,
    squadra,
    calciatore,
    crediti_min
  ).canJoin;
}

export function canRilanciare(squadra, crediti) {
  if (squadra.max_offerta < crediti) {
    return false;
  }
  return true;
}

export function canOffrire(squadra, crediti) {
  if (squadra.max_offerta < crediti) {
    return false;
  }
  return true;
}

export function getUniquePresences(connections) {
  let output = []
  for (let [key, conn] of Object.entries(connections)) {
    if (!output.includes(conn.presence)) {
      output.push(conn.presence)
    }
  }
  return output
}

export function isEmpty(obj) {
  if (obj && Object.keys(obj).length === 0) {
    return true;
  } else {
    return false;
  }
}

export function offertePiuAlte(offerte) {
  let output = []
  let oVincente = null
  _.forOwn(offerte, function(o, sq_id) {
    if (oVincente == null || o > oVincente) {
      oVincente = o
      output = []
      output.push({
        squadra_id: sq_id,
        offerta: o,
      })
    } else if (o == oVincente) {
      output.push({
        squadra_id: sq_id,
        offerta: o,
      })
    }
  });
  return output
}

// ritorna oggetto se c'è un vincitore unico
// Assegnabile si intende un'offerta tale che si possa assegnare il calciatore
// ritorna false altrimenti
export function vincenteUnicoAssegnabile(offerte) {
  //let offertePiuAlte = offertePiuAlte(offerte)
  /////////////////////////////////////////////
  let offertePiuAlte = []
  let oVincente = null
  _.forOwn(offerte, function(o, sq_id) {
    // console.log('--- sq_id', sq_id)
    // console.log('--- o', o)
    // console.log('--- oVincente', oVincente)
    if (oVincente == null || o > oVincente) {
      // console.log('resetta array')
      oVincente = o
      offertePiuAlte = []
      offertePiuAlte.push({
        squadra_id: sq_id,
        offerta: o,
      })
    } else if (o == oVincente) {
      // console.log('push array')
      offertePiuAlte.push({
        squadra_id: sq_id,
        offerta: o,
      })
    }
  });
  //////////////////////////////////////
  // console.log(offertePiuAlte)
  // console.log(offertePiuAlte.length)
  if (offertePiuAlte.length == 1 && offertePiuAlte[0].offerta >= Constants.OFFERTA.MINIMA) {
    // console.log(offertePiuAlte[0])
    return offertePiuAlte[0]
  }
  return false
}

export function console_log(myVar) {

  console.log(`Type: ${typeof myVar}`);

  if (typeof myVar === 'object') {
    for (const key in myVar) {
      if (myVar.hasOwnProperty(key)) {
        console.log(`Key: ${key}, Type: ${typeof key}, Value Type: ${typeof myVar[key]}`);
        if (typeof myVar[key] === 'object') {
          this.console_log(myVar[key])
        }
      }
    }
  }
}
